import { datadogRum } from '@datadog/browser-rum';

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  const errorsToIgnore = [
    'Login required',
    'Not allowed to access cross-origin stylesheet',
    'Ignored attempt to cancel a touchmove event', // Source GoogleMaps
    `can't access property "textContent", startElement is null`,
    'Page not found: /jobs/available.php',
    'Page not found: /jobs/dispatched.php',
  ];

  datadogRum.init({
    applicationId: config.public.ddApplicationId,
    clientToken: config.public.ddApplicationToken,
    site: 'datadoghq.com',
    service: config.public.ddServiceName,
    version: config.public.ddVersion,
    env: config.public.ddEnv,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    excludedActivityUrls: [/https:\/\/.*\.mixpanel\.com/],
    allowedTracingUrls: [
      /https:\/\/.*\.acvauctions\.com\/.*/,
      (url) => url.includes('transport-load-board-bff'),
      'https://transport-load-board-bff.gateway.latest.acvauctions.com/api/transport-requests/overdue/count',
      'https://transport-load-board-bff.gateway.internal.acvauctions.com/api/transport-requests/overdue/count',
      'https://transport-load-board-bff.gateway.staging.acvauctions.com/api/transport-requests/overdue/count',
    ],
    beforeSend: (event) => {
      if (event.type === 'error') {
        for (let i = 0; i < errorsToIgnore.length; i++) {
          if (event.error.message.includes(errorsToIgnore[i])) {
            return false;
          }
        }
      }
    },
  });
});
